import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React from 'react';
import Input from './Input';
import { View, Text, StyleSheet, TextInput } from 'react-native';
var styles = StyleSheet.create({
  answerWrapper: {
    position: 'relative'
  },
  textCount: {
    position: 'absolute',
    right: 0,
    top: -28,
    zIndex: 1,
    fontSize: 12,
    lineHeight: 14,
    textAlign: 'right',
    backgroundColor: 'white'
  },
  textCountStyle: {
    color: 'rgba(0, 0, 0, 0.54)',
    fontSize: 12,
    lineHeight: 14
  }
});
export default (function (props) {
  var _props$height = props.height,
    height = _props$height === void 0 ? 74 : _props$height,
    _props$hasTextCount = props.hasTextCount,
    hasTextCount = _props$hasTextCount === void 0 ? false : _props$hasTextCount;
  var _React$useState = React.useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    textCount = _React$useState2[0],
    setTextCount = _React$useState2[1];
  return hasTextCount ? /*#__PURE__*/React.createElement(View, {
    style: styles.answerWrapper
  }, /*#__PURE__*/React.createElement(View, {
    style: styles.textCount
  }, /*#__PURE__*/React.createElement(Text, {
    style: styles.textCountStyle
  }, textCount, "/", props.maxLength)), /*#__PURE__*/React.createElement(TextInput, {
    style: {
      height: height
    },
    maxLength: props.maxLength,
    onChangeText: function onChangeText(value) {
      var _props$onChange;
      setTextCount(value.length);
      props === null || props === void 0 ? void 0 : (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, value);
    },
    multiline: true,
    autoCorrect: false,
    allowFontScaling: false,
    onFocus: function onFocus(e) {
      var _props$onFocus;
      return props === null || props === void 0 ? void 0 : (_props$onFocus = props.onFocus) === null || _props$onFocus === void 0 ? void 0 : _props$onFocus.call(props, e);
    },
    onBlur: function onBlur() {
      var _props$onBlur;
      return props === null || props === void 0 ? void 0 : (_props$onBlur = props.onBlur) === null || _props$onBlur === void 0 ? void 0 : _props$onBlur.call(props);
    }
  })) : /*#__PURE__*/React.createElement(Input, _extends({}, props, {
    multiline: true,
    height: 124,
    wrapperStyle: props.isCaseCreation ? {
      borderWidth: 0
    } : {},
    inputContentStyle: props.isCaseCreation ? {
      marginLeft: 0
    } : {}
  }));
});